import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from "../../../Components/api/axiosInstance";

export const updateproject = createAsyncThunk(
  "updateproject",
  async ({ data, id }) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}/vessels/update-project/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  },
);

const updateProjectSlice = createSlice({
  name: "updateproject",
  initialState: {
    updateproject: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateproject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateproject.fulfilled, (state, action) => {
        state.loading = false;
        state.addproject = action.payload;
      })
      .addCase(updateproject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default updateProjectSlice.reducer;
